var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9583 60.9583H16.0417V25.6667H60.9583M51.3333 3.20833V9.62499H25.6667V3.20833H19.25V9.62499H16.0417C12.4804 9.62499 9.625 12.4804 9.625 16.0417V60.9583C9.625 62.6601 10.301 64.2922 11.5044 65.4956C12.7078 66.699 14.3399 67.375 16.0417 67.375H60.9583C62.6601 67.375 64.2922 66.699 65.4956 65.4956C66.699 64.2922 67.375 62.6601 67.375 60.9583V16.0417C67.375 14.3399 66.699 12.7078 65.4956 11.5044C64.2922 10.301 62.6601 9.62499 60.9583 9.62499H57.75V3.20833M54.5417 38.5H38.5V54.5417H54.5417V38.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCalendar);
export default __webpack_public_path__ + "static/media/mdi_calendar.9d0741785a926e0c38dc1d8868b5c880.svg";
export { ForwardRef as ReactComponent };